module.exports = __webpack_public_path__ + "static/media/back11.868236bf.jpg";